import { getRouteApi, useRouterState } from '@tanstack/react-router'
import { TableDataQa } from 'commons/types/enums'
import { Table } from 'ui/components'

import { PCTList } from '../../../types/PCT'
import { columns } from './columns'
import { FilterForm } from './components'

const routeApi = getRouteApi('/_app/bsa/pct-list')

export const PCTTable = () => {
  const data = routeApi.useLoaderData() as PCTList
  const {
    files,
    form: { page, size },
    total
  } = data

  const routerState = useRouterState()
  const navigate = routeApi.useNavigate()

  const onPagination = (page: number, size: number) => {
    navigate({ to: '.', search: (prev) => ({ ...prev, page, size }), resetScroll: false })
  }

  return (
    <>
      <FilterForm />
      <Table
        dataQa={TableDataQa.BP_CTR_LIST}
        columns={columns()}
        dataSource={files.map((item) => ({ item }))}
        pagination={{
          page,
          size,
          onChange: onPagination,
          total
        }}
        loading={routerState.status === 'pending'}
      />
    </>
  )
}
